import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import Navbar from "../Navbar/Navbaranim";
import Services from "./Services/Services";
import Assessment from "./Assessment/Assessment";
import Question from "./Question/Question";
import Scans from "./Scans/Scans";
import Process from "./Process/Process";
import Protection from "./Protection/Protection";
import Report from "./Reports/Reports";
import ContactUs from "../ContactUs/Contactus";
import Footer from "../Footer/Footer";
import { Dimensions } from "../Helper/sitedimension";
import "./Servicespage.css";

const ServicePage = () => {
  const { width } = Dimensions.useWindowDimensions();
  return (
    <div className="ServicePage">
      <Navbar className="navbar" />
      <Services className="services1" />
      {width > 500 ? <Assessment className="assesment" /> : null}
      <Question className="question" />
      {width > 500 ? <Scans className="scans" /> : null}
      <Process className="process" />
      {width > 500 ? <Protection className="protection" /> : null}
      <Report className="reports" />
      {width > 500 ? (
        <ContactUs className="contactus" />
      ) : (
        <ContactUs className="conmobile" />
      )}
      <Footer className="footer" />
    </div>
  );
};

export default ServicePage;
